<!--
 * @Description: 个体自然人完税证明详情
 * @Date: 2023-02-24 14:02:57
-->
<template>
  <el-dialog
    title="完税证明"
    :before-close="() => $emit('close')"
    :visible="true"
    width="900px"
    center
    append-to-body
  >
    <el-form inline ref="ruleForm" :model="ruleFormData" label-width="120px">
      <el-form-item label="个体名称" prop="enterpriseIdentifierName">
        <el-input
          disabled
          v-model="ruleFormData.enterpriseIdentifierName"
        ></el-input>
      </el-form-item>
      <el-form-item label="征收项目" prop="feeProjectName">
        <el-input
          :disabled="true"
          v-model="ruleFormData.feeProjectName"
        ></el-input>
      </el-form-item>
      <el-form-item label="征收品目" prop="feeItemName">
        <el-input disabled v-model="ruleFormData.feeItemName"></el-input>
      </el-form-item>
      <el-form-item label="缴费状态" prop="feeStatus">
        <el-select :disabled="true" v-model="ruleFormData.feeStatus">
          <el-option label="未缴费" :value="0"></el-option>
          <el-option label="已缴费" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="完税证明附件">
        <div style="width:600px;" v-if="ruleFormData.attachments.length > 0">
          <a
            style="margin-right:5px;color:#409eff"
            target="_blank"
            v-for="(item, index) in ruleFormData.attachments"
            :key="index"
            :download="item.attachmentUrl"
            :href="`${config.fileViewUrl}?url=${item.attachmentUrl}`"
          >
            {{ item.attachementName }}
          </a>
        </div>
        <div v-else style="width:600px;"></div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { taxPayment } from '@/api/ajax';
import config from '@/config';

export default {
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      config,
      ruleFormData: {
        enterpriseIdentifierName: '',
        feeProjectName: '',
        feeItemName: '',
        feeStatus: '',
        attachments: []
      }
    };
  },
  methods: {},
  async created() {
    const { pdata } = await taxPayment.individualPerson.proofAttById({
      id: this.row.id
    });
    this.ruleFormData = pdata;
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    width: 220px;
  }
}
</style>
